.group {
  margin-block: var(--tuna-spacing-2);
}

.groupHeader {
  display: flex;
  align-items: baseline;
  gap: var(--tuna-spacing-1);
  margin-block-end: var(--tuna-spacing-0_5);
}

/* The closed result: one row per group, group name then its winner(s). */
.results {
  display: grid;
  row-gap: var(--tuna-spacing-1);
  margin-block: var(--tuna-spacing-2);
  padding: 0;
  list-style: none;
}

.resultRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-1) var(--tuna-spacing-2);
}

.winner {
  display: inline-flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

.notice {
  display: block;
  margin-block: var(--tuna-spacing-1);
}
